import { useProxyWatch, useTranslation } from '@fanfanlo'
import { Box, Grid2 } from '@mui/material'
import { ITriggerTimeoutData } from './ITriggerTimeout.inft'

export function UI(data: ITriggerTimeoutData) {
    const { t } = useTranslation('droid-project-v2-ext/triggers/time/timeout/content')
    const [time] = useProxyWatch(data, 'javaData.time', data.javaData.time)
    return (
        <>
            <Box sx={{ width: '100%' }}>
                <Box>
                    <b>{t('UI.title')}</b>
                </Box>
                <Grid2 container sx={{ width: '100%' }}>
                    <Grid2 size="grow" container>
                        <Box>
                            <span>{t('UI.content_delay')}</span>
                            <span>
                                <input
                                    id="trigger-timeout-value-input"
                                    data-id="trigger-timeout-value-input"
                                    data-testid="TimeoutUI__timeInput__01JFXYZQ0G6H7I8J9K0L1M2N3"
                                    type="number"
                                    value={time}
                                    onChange={e => {
                                        data.javaData.time = Number(e.target.value)
                                    }}
                                />
                            </span>
                            <span>{t('UI.content_milliseconds')}</span>
                        </Box>
                    </Grid2>
                </Grid2>
            </Box>
        </>
    )
}
